import { createRoot } from "react-dom/client";
import App from "./components/App";
import "./index.css";
import { HashRouter as Router } from "react-router-dom";
import { msalInstance } from './services/MSALConfig';
import { MsalProvider } from "@azure/msal-react";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
<Router>
  <MsalProvider instance={msalInstance}>
    <App/>
  </MsalProvider>
</Router>
);